<template>
    <div>
        <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields" :permission="permission"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "AppDownload",
        components: {CommonTable},
        data(){
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }],
                permission:{
                    add: 'appDownload:add',
                    update: 'appDownload:update',
                    delete: 'appDownload:delete',
                    deleteBatch: 'appDownload:deleteBatch'
                },
                url: {
                    get: '/appDownload/listByCondition',
                    add: '/appDownload/add',
                    update: '/appDownload/update',
                    delete: '/appDownload/delete/',
                    delete_batch: '/appDownload/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '100',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'url',
                    label: '下载链接',
                    show: true,
                    width: '',
                }/*, {
                    field: 'version',
                    label: '版本',
                    show: true,
                    width: '',
                }, {
                    field: 'forceUpdate',
                    label: '强制更新',
                    show: {
                        type: 'select',
                    },
                    selectData: [{
                        id: 0,
                        name: '不强制更新'
                    }, {
                        id: 1,
                        name: '强制更新'
                    }],
                    width: '',
                }, {
                    field: 'type',
                    label: '更新类型',
                    show: {
                        type: 'select',
                    },
                    selectData: [{
                        id: 0,
                        name: '所有人不可见'
                    }, {
                        id: 1,
                        name: '所有人都可见'
                    },{
                        id: 2,
                        name: '仅IP白名单可见'
                    }],
                    width: '',
                }, {
                    field: 'platform',
                    label: '平台',
                    show: {
                        type: 'select',
                    },
                    selectData: [{
                        id: 0,
                        name: 'android'
                    }, {
                        id: 1,
                        name: 'ios'
                    }],
                    width: '',
                }, {
                    field: 'versionNum',
                    label: '版本号',
                    show: true,
                    width: '',
                }*/,{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加应用下载链接',
                    updateTitle: '修改应用下载链接',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择代理', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'url',
                        label: '下载链接',
                        type: 'input',
                        placeholder: '下载链接',
                        rules:[{message: '请输入下载链接', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }/*, {
                        field: 'version',
                        label: '版本',
                        type: 'input',
                        placeholder: '版本',
                        rules:[{message: '请输入版本', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    },{
                        field: 'forceUpdate',
                        label: '强制更新',
                        type: 'select',
                        selectData: [{
                            id: 0,
                            name: '不强制更新'
                        }, {
                            id: 1,
                            name: '强制更新'
                        }],
                        placeholder: '是否强制更新',
                        rules:[{
                            message: '请选择是否强制更新', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    },{
                        field: 'type',
                        label: '更新类型',
                        type: 'select',
                        selectData: [{
                            id: 0,
                            name: '所有人不可见'
                        }, {
                            id: 1,
                            name: '所有人都可见'
                        }, {
                            id: 2,
                            name: '仅IP白名单可见'
                        }],
                        placeholder: '请选择更新类型',
                        rules:[{
                            message: '请选择更新类型', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    },{
                        field: 'platform',
                        label: '平台',
                        type: 'select',
                        selectData: [{
                            id: 0,
                            name: 'android'
                        }, {
                            id: 1,
                            name: 'ios'
                        }],
                        placeholder: '请选择平台',
                        rules:[{
                            message: '请选择平台', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'versionNum',
                        label: '版本号',
                        type: 'input',
                        placeholder: '版本号',
                        rules:[{message: '请输入版本号', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }*/],
                }
            }
        }
    }
</script>

<style scoped>

</style>
